import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LimitReportListBaseComponent } from '@backoffice-frontend/limit-report/domain';
import { LimitReportOtherListFacade } from '../../services/limit-report-list.facade';

@Component({
    selector: 'backoffice-frontend-limit-report-other-list',
    templateUrl: './limit-report-list.component.html',
    styleUrls: ['./limit-report-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LimitReportOtherListComponent extends LimitReportListBaseComponent {
  protected baseNavigateUrl = '/limit-reports/other';

  constructor(service: LimitReportOtherListFacade) {
    super(service);
  }
}
